import { Route, Routes } from "react-router-dom"
import { I18nProvider } from "./i18n"
import { HomePage } from "./pages/HomePage"
import { PrivacyPolicyPage } from "./pages/legal/PrivacyPolicyPage"
import { TermsPage } from "./pages/legal/TermsPage"
import { ThemeProvider } from "./theme"

export const App = () => {
  return (
    <I18nProvider>
      <ThemeProvider>
        {/* Background and foreground come from the active CSS variables.
            `bg-background` resolves against @tessel/ui's :root / .dark blocks
            so the wrapper itself reacts to the toggle. The "grimoire" palette
            for the landing's sections is consumed via usePalette() in the
            individual components. */}
        <div className="min-h-screen bg-background text-foreground">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/privacy" element={<PrivacyPolicyPage />} />
            <Route path="/legal" element={<TermsPage />} />
          </Routes>
        </div>
      </ThemeProvider>
    </I18nProvider>
  )
}
